import React, { useContext } from 'react';
import AppLayout from '../AppLayout';
import { IntlProvider } from 'react-intl';
import DateFnsUtils from '@date-io/date-fns';
import { themeV5 } from '../../theme/v5ThemeProvider';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import ThemeProvider from '@material-ui/styles/ThemeProvider';
import { createTheme, StylesProvider } from '@material-ui/core/styles';
import AppContext from '../contextProvider/AppContextProvider/AppContext';
import { ThemeProvider as MuiThemeProviderV5 } from '@mui/material/styles';

const AppWrapper = ({ match, location, children }) => {
  const { theme } = useContext(AppContext);

  return (
    <IntlProvider>
      <MuiThemeProviderV5 theme={themeV5}>
        <ThemeProvider theme={createTheme(theme)}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <StylesProvider>
              <CssBaseline />
              <AppLayout>{children}</AppLayout>
            </StylesProvider>
          </MuiPickersUtilsProvider>
        </ThemeProvider>
      </MuiThemeProviderV5>
    </IntlProvider>
  );
};

export default AppWrapper;
